var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.15,
    viewBox: "0 0 21.5 21.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_167916",
    "data-name": "Group 167916",
    transform: "translate(-1.25 -1.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51370",
    "data-name": "Path 51370",
    d: "M14.46,3.26l.88-.88a2.815,2.815,0,0,1,3.89,0l.71.71a2.732,2.732,0,0,1,0,3.88l-.88.88-4.6-4.6ZM13.4,4.32,4.29,13.43a1.7,1.7,0,0,0-.5,1.08l-.27,2.93a1.285,1.285,0,0,0,.36,1,1.234,1.234,0,0,0,.88.37h.11l2.93-.27a1.767,1.767,0,0,0,1.08-.51l9.11-9.11-4.6-4.6ZM22.75,22a.755.755,0,0,0-.75-.75H2a.75.75,0,0,0,0,1.5H22A.755.755,0,0,0,22.75,22Z",
    fill: "#5460d1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.fca1bd7c1b462b5ffa8d56d5e7f410bd.svg";
export { ForwardRef as ReactComponent };